<template>
  <span>
    <a-modal
      class="process-card"
      title="批量办理"
      :visible="visible"
      @ok="handleOk"
      v-if="visible"
      @cancel="handleCancel">
      <span v-if="showProcess === 'stp1'">
      <p class="process-info">
          <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#d18a17"/>
          批量操作将会对勾选的流程全部生效，不可撤销，请谨慎操作。<br/><br/>
      </p>
      <a-radio-group v-model="valueId" class="mg">
            <a-radio v-for="(item,idx) in actionIds" :value="item.id" :key="idx">
                {{item.name}}
            </a-radio>
      </a-radio-group>
      </span>

      <span v-if="showProcess === 'stp2'">
          <a-progress
              :stroke-color="{
                from: lineColor[0],
                to: lineColor[1],
              }"
              :percent="percentNow"
              status="active" />
      </span>

      <span v-if="showProcess === 'stp3'">
          <div v-for="(item,idx) in resError">
            <p><a-tag :color="lineColor[0]">流水号</a-tag>{{item.entry}}</p>
            <p><a-tag :color="lineColor[1]">出错信息</a-tag>{{item.error}}</p>
          </div>
      </span>

    </a-modal>
  </span>
</template>
<script>
import qs from 'qs';
export default {
  data() {
    return {
      valueId:1,
      actionIds:[],
      showProcess:'stp1',
      resCount:0,
      percentOne:0,
      end:false,
      resError:[],
      visible:false
    };
  },
  inject:['getDataSource','reload'],
  computed:{
    percentNow(){
      let num = this.end ? 100 : this.percentOne*this.resCount ;
      return num;
    },
    targetEntry(){
      let obj = {};
      let metas = this.getDataSource('todo');
      for(let i in metas){
        obj[metas[i].id] = metas[i].process.entry;
      }
      return obj;
    },
  },
  props:{
    lineColor:{
      type:Array,
      default:()=>{
        return ['#108ee9','#87d068']
      }
    }
  },
  methods: {
    showModal(e) {
        let rely = e.split('——');
        let actionIds = this.getDataSource('todo').filter((item)=>{
            return item.process.app.name === rely[0] && item.name === rely[1];
        })[0].actions

        this.actionIds = actionIds;

        this.showProcess = 'stp1';
        this.end = false;
        this.resCount = 0;
        this.resError=[];
        this.visible = true;
        this.valueId=0;
    },
    endProcess(){
      this.end = true;
      if(this.resError.length>0){
        this.showProcess = 'stp3';
				this.$store.dispatch('resetData',{dataName:'todo'});
        this.$store.dispatch('process_push',{id:null,isok:null,clear:true});
      }else{
        let self = this;
        var delay = setTimeout(()=>{
            self.$message.success('批量办理完成！');
            self.$store.dispatch('process_push',{id:null,isok:null,clear:true});
				    self.$store.dispatch('resetData',{dataName:'todo'});
            self.visible = false;
            clearTimeout(delay);
        },1000);    
      }

      this.$emit('refresh');
    },
    handleOk(e) {
      if(this.showProcess === 'stp1'){
        let ids = this.$store.getters.getState.process_pass;
        let actionId = this.valueId;
        let allresCount = 0;
        this.showProcess = 'stp2';
        this.percentOne = parseInt(100 / ids.length);

        let self = this;
		    ids.map((id,idx)=>{
			  this.$axios.post(`${window.commonApi.INFOPLUS_URL}/task/${id}`,qs.stringify({"actionId":actionId})).then((res) => {
				if (res.data.errno === 0 ) {
					self.resCount = self.resCount + 1;
          // console.log(self.resCount);
				}else{
          this.resError.push({
            entry:this.targetEntry[id],
            error:res.data.error
          })
        }
        allresCount++;
        if(ids.length === allresCount){
          this.endProcess();
        }
			})
			.catch(function (error) {
        this.resError.push({
            entry:this.targetEntry[id],
            error
          })
			})
		});
      }else{
        this.visible = false;
      }

    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/todoCenter/process.vue